module.exports = __webpack_public_path__ + "media/images/noticia07-4673c7a8a4ba63fdf33c19c718b6401e.jpg";